// Centralized profile data for the portfolio

const profile = {
  identity: {
    fullName: 'Faustin AGOHOUNDJE',
    title: 'Développeur Full Stack',
    yearsOfExperience: 3,
    shortBio:
      "Passionné par le développement web, je conçois des applications modernes et performantes.",
    location: 'Paris, France',
  },

  contact: {
    email: 'faustinagohoundje@gmail.com',
    phone: '+229 01 96 39 98 09',
    city: 'Calavi',
    country: 'Bénin',
  },

  socials: {
    github: 'https://github.com/Kcfaustin',
    linkedin: '#',
    twitter: '#',
    email: 'mailto:faustinagohoundje@gmail.com',
  },

  assets: {
    heroImage: '/assets/moi.jpg',
    aboutImage: '/assets/moi.jpg',
    cvUrl: '/assets/CV_BENIN_AG_FAUSTIN_A.pdf',
    companies: [
      { name: 'Google', logo: '/assets/companies/google.png' },
      { name: 'Amazon', logo: '/assets/companies/amazon.png' },
      { name: 'Meta', logo: '/assets/companies/meta.webp' },
    ],
  },

  skills: {
    categories: [
      {
        title: 'Frontend',
        skills: [
          { name: 'React', level: 45, logo: '/assets/techno/react.png' },
          { name: 'JavaScript', level: 40, logo: '/assets/techno/js.png' },
          { name: 'TypeScript', level: 25, logo: '/assets/techno/typescript.svg' },
          { name: 'HTML/CSS', level: 75, logo: '/assets/techno/html.png' },
          { name: 'Tailwind CSS', level: 25, logo: '/assets/techno/tailwind.png' },
        ],
      },
      {
        title: 'Backend',
        skills: [
          { name: 'Laravel', level: 80, logo: '/assets/techno/laravel.png' },
          { name: 'PHP', level: 75, logo: '/assets/techno/php.png' },
        ],
      },
      {
        title: 'Mobile',
        skills: [
          { name: 'Flutter', level: 40, logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg' },
        ],
      },
    ],
    technologies: [
      { name: 'React', logo: '/assets/techno/react.png' },
      { name: 'JavaScript', logo: '/assets/techno/js.png' },
      { name: 'TypeScript', logo: '/assets/techno/typescript.svg' },
      { name: 'HTML', logo: '/assets/techno/html.png' },
      { name: 'CSS', logo: '/assets/techno/css.png' },
      { name: 'Tailwind', logo: '/assets/techno/tailwind.png' },
      { name: 'Laravel', logo: '/assets/techno/laravel.png' },
      { name: 'PHP', logo: '/assets/techno/php.png' },
      { name: 'Flutter', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg' },
    ],
  },

  projects: [
    {
      id: 1,
      title: 'NéphroSuivi',
      description:
        "Plateforme spécialisée pour les professionnels de santé dédiée au suivi et à la gestion des patients atteints de maladies rénales chroniques.",
      image: '/assets/projects/11.PNG',
      technologies: ['React', 'Next.js', 'MySQL'],
      category: 'web',
      link: 'https://projet-front-end.vercel.app',
      github: 'https://github.com/Kcfaustin/PROJET-AI4CKD-front-end',
    },
    {
      id: 2,
      title: 'StudentLink',
      description:
        "La plateforme qui releve les talents étudiants et les connecte aux opportunités professionnelles.",
      image: '/assets/projects/connect.PNG',
      technologies: ['Laravel', 'React', 'PostgreSQL'],
      category: 'web',
      link: 'https://studenlink.faustinagh.me/',
      github: '#',
    },
    /* {
      id: 3,
      title: 'Mobile App',
      description: 'Application mobile cross-platform avec synchronisation cloud.',
      image: '/assets/projects/3.png',
      technologies: ['Flutter', 'Firebase'],
      category: 'mobile',
      link: '#',
      github: '#',
    }, */
    {
      id: 4,
      title: 'API REST NéphroSuivi',
      description:
        'API RESTful robuste avec authentification et documentation complète.',
      image: '/assets/projects/api.PNG',
      technologies: ['Laravel', 'Swagger'],
      category: 'backend',
      link: 'https://nephrosuiviapi.faustinagh.me',
      github: 'https://github.com/Kcfaustin/PROJET-AI4CKD-backend',
    },
    {
      id: 5,
      title: 'Portfolio Website',
      description:
        'Site portfolio moderne et responsive avec animations fluides.',
      image: '/assets/projects/22.PNG',
      technologies: ['React', 'Tailwind CSS', 'Node.js'],
      category: 'web',
      link: 'https://faustinagh.me/',
      github: 'https://github.com/Kcfaustin/MyPortfolio',
    },
    {
      id: 6,
      title: 'Gestion des Tâches',
      description:
        'Application de gestion de tâches collaborative avec temps réel.',
      image: '/assets/projects/33.PNG',
      technologies: ['PHP', 'Laravel', 'MySQL'],
      category: 'web',
      link: 'https://gestiondestaches.faustinagh.me',
      github: 'https://github.com/Kcfaustin/Gestion-de-Taches-Collaboratives',
    },
    {
      id: 7,
      title: 'Biométrie Boost',
      description:
        'Plateforme d\'accompagnement complet pour les ressortissants francophones (Togo/Bénin) devant effectuer leur collecte biométrique à Accra (Ghana) pour leur demande de visa canadien. Services incluant transport, hébergement, assistance documentaire et support 24/7.',
      image: '/assets/projects/biometrie.PNG',
      technologies: ['React', 'JavaScript', 'CSS', 'Laravel'],
      category: 'web',
      link: 'https://biometrieboost.com/',
      github: '#',
    },
    {
      id: 8,
      title: 'AlertBolt',
      description: 'Plateforme spécialisée dans les alertes de marché et de la veille.',
      image: '/assets/projects/alertbolt.PNG',
      technologies: ['Laravel', 'React', 'PHP'],
      category: 'mobile',
      link: 'https://marketalert.faustinagh.me/',
      github: '#',
    },
  ],
};

export default profile;


